/**
 * 방화벽, NAT 정책 utils
 *  - 추후 파일 위치 변경 필요(구조화)
 * 필수 속성 추출
 *
 * @since 2018-12-05
 * @author kdydesign.kim
 */

const pickData = (pd, pc) => _.pick(pd, pc)

/**
 * 주소 객체 필수 속성 추출
 * @param data
 * @returns {*}
 */
export const pickAddressData = (data) => {
  const pickCon = ['addr_obj_id', 'addr_obj_type', 'excpt', 'weight']

  if (_.isArray(data)) {
    return _.map(data, obj => pickData(obj, pickCon))
  }

  if (_.isPlainObject(data)) {
    return pickData(data, pickCon)
  }
}

/**
 * 서비스 객체 필수 속성 추출
 * @param data
 * @returns {*}
 */
export const pickServiceData = (data) => {
  const pickCon = ['srv_obj_id']

  if (_.isArray(data)) {
    return _.map(data, obj => pickData(obj, pickCon))
  }

  if (_.isPlainObject(data)) {
    return pickData(data, pickCon)
  }
}

/**
 * 사용자 객체 필수 속성 추출
 * @param data
 * @returns {*}
 */
export const pickUserData = (data) => {
  const pickUserData = (pd) => {
    const objType = Number(pd.usr_obj_type)
    const pick = ['usr_obj_type']

    if (objType === 0) {
      return {
        usr_obj_id: 0,
        usr_obj_type: 0
      }
    }

    if (objType === 1) {
      return _.pick(pd, _.concat(pick, 'usr_obj_id'))
    }

    if (objType === 2) {
      return _.pick(pd, _.concat(pick, 'usr_grp_id'))
    }

    if (objType === 3) {
      return _.pick(pd, _.concat(pick, ['ip_map_svr_id', 'ip_map_usr_id']))
    }

    if (objType === 4) {
      return _.pick(pd, _.concat(pick, 'ip_map_grp_id'))
    }

    if (objType === 5) {
      return _.pick(pd, _.concat(pick, 'ad_map_usr'))
    }

    if (objType === 6) {
      return _.pick(pd, _.concat(pick, 'ad_map_grp'))
    }

    if (objType === 7 || objType === 8 || objType === 9) {
      return _.pick(pd, _.concat(pick, 'str_name'))
    }
  }

  if (_.isArray(data)) {
    return _.map(data, obj => pickUserData(obj))
  }

  if (_.isPlainObject(data)) {
    return pickUserData(data)
  }
}

/**
 * 앱 객체
 * @param data
 * @returns {Array}
 */
export const pickAppData = (data) => {
  // TAMS (NGF: app_obj_type -> app_type, type -> app_obj_type)
  const pickCon = ['app_obj_id', 'app_type', 'app_filter_obj_id']

  if (_.isArray(data)) {
    return _.map(data, obj => pickData(obj, pickCon))
  }

  if (_.isPlainObject(data)) {
    return pickData(data, pickCon)
  }
}

/**
 * 디바이스 객체 필수 속성 추출
 * @param data
 * @returns {Array}
 */
export const pickDeviceData = (data) => {
  const pickCon = ['dvc_obj_id', 'dvc_obj_type', 'dvc_grp_id']

  if (_.isArray(data)) {
    return _.map(data, obj => pickData(obj, pickCon))
  }

  if (_.isPlainObject(data)) {
    return pickData(data, pickCon)
  }
}

// TAMS
export const checkPamsObj = (selectedData, objectType) => {
  const PAMS_OBJ_PREFIX = 'P_'
  let objFiledName = ''
  if (objectType === 'service') {
    objFiledName = 'srv_obj_uname'
  } else if (objectType === 'time') {
    objFiledName = 'time_obj_uname'
  } else if (objectType.indexOf('address') > -1) {
    objFiledName = 'addr_obj_uname'
  }
  return typeof selectedData[objFiledName] === 'string' ? _.startsWith(selectedData[objFiledName], PAMS_OBJ_PREFIX) : false
}

export const findIndexOf = (data = [], keyword = '') => {
  return _.findIndex(data, o => {
    return o.indexOf(keyword) !== -1
  })
}

// TAMS
export const convertSearchTemplateToSearchType = (template) => {
  let searchType = void 0
  switch (template) {
    // 편집 정책 검색 - 방화벽 정책 내용 검색
    case 'policyContentsTemplate':
      searchType = 'contents'
      break
    // 편집 정책 검색 - 시간 만료 검색
    case 'timeoutPolicyTemplate':
      searchType = 'timeout'
      break
    // 편집 정책 검색 - shadow 정책 검색
    case 'shadowPolicyTemplate':
      searchType = 'shadow'
      break
    // 편집 정책 검색 - NAT 정책 내용 검색 (TAMS 미사용)
    case 'natPolicyContentsTemplate':
      searchType = 'natContents'
      break
    default:
      searchType = 'contents'
  }
  return searchType
}

export const convertSearchTypeToSearchTemplate = (type) => {
  let searchTemplate = void 0
  switch (type) {
    // 편집 정책 검색 - 방화벽 정책 내용 검색
    case 'contents':
      searchTemplate = 'policyContentsTemplate'
      break
    // 편집 정책 검색 - 시간 만료 검색
    case 'timeout':
      searchTemplate = 'timeoutPolicyTemplate'
      break
    // 편집 정책 검색 - shadow 정책 검색
    case 'shadow':
      searchTemplate = 'shadowPolicyTemplate'
      break
    // 편집 정책 검색 - NAT 정책 내용 검색 (TAMS 미사용)
    case 'natContents':
      searchTemplate = 'natPolicyContentsTemplate'
      break
    default:
      searchTemplate = void 0
      break
  }
  return searchTemplate
}

// TAMS
export const getKeybyObjectType = (objectType) => {
  try {
    let res = ''
    if (objectType === 'webCategory') {
      res = 'web_cate_obj_id'
    } else if (objectType.indexOf('application') > -1) {
      res = objectType !== 'applicationFilter' ? 'app_obj_id' : 'app_filter_obj_id'
    } else if (objectType === 'service' || objectType === 'serviceGroup') {
      res = 'srv_obj_id'
    } else if (objectType === 'time') {
      res = 'time_obj_id'
    } else if (objectType.indexOf('address') > -1) {
      res = 'addr_obj_id'
    }
    return res
  } catch (e) {
    window.$nuxt.$log('[Policy Utils GUI Error (getKeybyObjectType)]', e)
  }
}

// TAMS
export const getKeybyProfileType = (profileType) => {
  try {
    let res = ''
    if (profileType === 'filetype') {
      res = 'file_type_ctrl_prf_id'
    } else if (profileType === 'dlp') {
      res = 'dlp_prf_id'
    } else if (profileType === 'av') {
      res = 'av_prf_id'
    } else if (profileType === 'as') {
      res = 'as_prf_id'
    } else if (profileType === 'wf') {
      res = 'wf_prf_id'
    } else if (profileType === 'apt') {
      res = 'apt_prf_id'
    } else if (profileType === 'ips') {
      res = 'ips_prf_id'
    }
    return res
  } catch (e) {
    window.$nuxt.$log('[Policy Utils GUI Error (getKeybyProfileType)]', e)
  }
}

// 방화벽 정책 순번(seq) 업데이트
export function updateRuleSeq (state) {
  let fwRuleSeq = 1
  state.fwRulesList = Object.freeze(_.map(state.fwRulesList, (o) => {
    if (!o.is_group) {
      o.fw_rule_seq = fwRuleSeq
      fwRuleSeq++
    }
    return o
  }))
}
// 방화벽 정책 - 주소 객체 데이터
export function initFwRulesAddressData () {
  return [
    {
      addr_obj_id: 0,
      addr_obj_except_yn: 0,
      name: 'Any',
      addr_obj_type: 0
    }
  ]
}
// 방화벽 정책 - 서비스 객체 데이터
export function initFwRulesServiceData () {
  return [
    {
      srv_obj_id: 0,
      name: 'Any',
      srv_obj_type: 0
    }
  ]
}
// 방화벽 정책 - 애플리케이션 객체 데이터
export function initFwRulesApplicationData () {
  return [
    {
      app_obj_id: 0,
      name: 'Any',
      app_type: 0
    }
  ]
}
export function initSecurityProfileData () {
  return {
    ips_prf: void 0,
    av_prf: void 0,
    as_prf: void 0,
    wf_prf: void 0,
    dlp_prf: void 0,
    file_type_ctrl_prf: void 0,
    apt_prf: void 0
  }
}
export function initFwRuleAll () {
  return [
    {
      src_addr_obj: initFwRulesAddressData(),
      dst_addr_obj: initFwRulesAddressData(),
      srv_obj: initFwRulesServiceData(),
      app_obj: initFwRulesApplicationData(),
      fw_rule_uname: void 0,
      fw_rule_action_type: 1,
      fw_rule_bidir_yn: 0,
      fw_rule_log_yn: 1,
      fw_rule_tcp_flag_yn: 0,
      fw_rule_id: 0,
      fw_rule_desc: '',
      time_obj_id: 0,
      fw_rule_use_yn: 1,
      fw_rule_inhrit_yn: 1,
      fw_rule_sess_limit_block_yn: 0,
      fw_rule_sess_limit_ip_num: 10000,
      fw_rule_sess_limit_num: 10000,
      fw_rule_sess_limit_type: 0,
      security_profile: initSecurityProfileData()
    }
  ]
}
// IPv4 방화벽 정책 데이터
export function initFwV4RulesData () {
  return {
    fw_grp_id: 1,
    device_id: 1,
    fw_grp_seq: 1,
    fw_grp_uname: '', // top, bottom, pams
    fw_grp_desc: '',
    fw_rule: initFwRuleAll(),
    fw_selected_rule_seq: 1
  }
}
// IPv6 방화벽 정책 데이터
export function initFwV6RulesData () {
  return {
    fw_grp_id: 1,
    device_id: 1,
    fw_grp_seq: 1,
    fw_grp_uname: '', // top, bottom, pams
    fw_grp_desc: '',
    fw_rule: initFwRuleAll(),
    fw_selected_rule_seq: 1,
    fw_rule_ext_header_set: {
      fragment: 0,
      auth: 0,
      dest: 0,
      esp: 0,
      hop: 0,
      routing: 0
    }
  }
}
export function initTreeInfo () {
  return {
    text: '',
    id: 0,
    device_model_type: 0,
    device_real_ver_val: 0
  }
}
export function initFwPage () {
  return {
    page_max: 1,
    page_pos: 1,
    page_cnt: 50,
    total_cnt: 0,
    disabled_cnt: 0,
    enabled_cnt: 0,
    expired_cnt: 0
  }
}
// TAMS 그룹 열림/닫힘
export function initClosedFwGroups (closed = false) {
  return {
    inhrit_top: closed,
    top: closed,
    pams: closed,
    bottom: closed,
    inhrit_bottom: closed
  }
}
export function getDefaultState (version = 4) {
  return {
    version: version,
    multipleSelect: false,
    isSelectCell: false,
    fwRulesList: [],
    fwDetailRulesDataList: [],
    fwRulesData: version === 4 ? initFwV4RulesData() : initFwV6RulesData(),
    fwRuleTimeData: void 0,
    selectedPolicyData: void 0,
    searchSelectedPolicyData: void 0,
    selectedAddObjectData: void 0,
    copyFwRulesData: void 0,
    copyFwInObject: void 0,
    singleFlag: false, // 한개만 입력받는 GUI에서 사용,
    usedQoSDataList: [],
    disablePamsControlRule: false, // PAMS 정책 선택 여부 확인 (예외처리용)
    treeInfo: initTreeInfo(),
    fwEachRuleStore: [],
    filterType: 1,
    selectGroupList: [], // TAMS는 top/bottom id가 변경되기 때문에 테이블 데이터 조회시에 갱신해줘야한다.
    fwPage: initFwPage(),
    closedFwGrps: initClosedFwGroups(),
    fwGroupList: [] // Server side paging 조회 시 List 내 방화벽 그룹 정보 (fw_group)
  }
}

export function parseBatchValue (rules, batchValue) {
  _.mapKeys(batchValue, (value, key) => {
    if (key === 'security_profile') {
      _.mapKeys(value, (value2, key2) => {
        if (value2 && !value2.id) value[key2] = void 0
      })
      rules[key] = _.assign(rules[key], batchValue[key])
    } else {
      rules[key] = batchValue[key]
    }
  })
  return rules
}

export function binarySearch (arr, seq, min, max) {
  if (max < min) return -1
  let mid = Math.floor((min + max) / 2)
  if (!arr[mid].is_group) { // 그룹이 아닐 경우
    if (arr[mid].seq < seq) {
      return binarySearch(arr, seq, mid + 1, max)
    } else if (arr[mid].seq > seq) {
      return binarySearch(arr, seq, min, mid - 1)
    }
    return mid
  }
  // 그룹 일 경우
  for (let i = mid + 1; i <= max; i++) {
    if (!arr[i].is_group) {
      mid = i
      break
    }
  }
  if (arr[mid].is_group) {
    // 그룹 일 경우 역순 검색
    for (let i = mid - 1; i >= min; i--) {
      if (!arr[i].is_group) {
        mid = i
        break
      }
    }
  }
  if (arr[mid].seq < seq) {
    return binarySearch(arr, seq, mid + 1, max)
  } else if (arr[mid].seq > seq) {
    return binarySearch(arr, seq, min, mid - 1)
  }
  return mid
}

export function resFwRulesList (res, closedFwGrp) {
  const selectGroupList = [], fwRulesList = res.result.fw_grps, fwGroupList = [] // 상속 Top/Bottom, 대상 장비 Top/Bootom, Pams
  const fwEachRule = []
  let virtualPageCount = 0, pageMaxCount = res.result.total_cnt
  const minPageIdx = res.result.page_pos === 1 ? 0 : (res.result.page_cnt * (res.result.page_pos - 1))
  const maxPageIdx = res.result.page_pos * res.result.page_cnt - 1
  fwRulesList.forEach((row) => {
    if (['top', 'bottom'].includes(row.fw_grp_uname)) selectGroupList.push({ label: row.fw_grp_uname, value: row.fw_grp_id }) // 그룹 리스트 생성 (2건)
    fwGroupList.push({ // 그룹 row - update
      is_closed: row.is_closed,
      fw_grp_seq: row.fw_grp_seq,
      fw_grp_id: row.fw_grp_id,
      fw_grp_uname: row.fw_grp_uname,
      total_cnt: row.total_cnt || 0,
      enabled_cnt: row.enabled_cnt || 0,
      disabled_cnt: row.disabled_cnt || 0
    })
    closedFwGrp[row.fw_grp_uname] = _.get(row, ['is_closed'], false)
    // TAMS, 정책 그룹 펼침/접힘에 따른 페이징에 따른 그룹행 표현 계산
    if (virtualPageCount <= maxPageIdx && row.is_closed) {
      if (virtualPageCount >= minPageIdx) {
        fwEachRule.push({
          is_group: true,
          is_open: !row.is_closed,
          seq: row.fw_grp_seq,
          fw_grp_id: row.fw_grp_id,
          name: row.fw_grp_uname,
          total_cnt: row.total_cnt || 0,
          enabled_cnt: row.enabled_cnt || 0,
          disabled_cnt: row.disabled_cnt || 0
        })
      }
    } else if (virtualPageCount <= maxPageIdx) {
      virtualPageCount += row.total_cnt
      if (virtualPageCount >= minPageIdx) {
        fwEachRule.push({
          is_group: true,
          is_open: !row.is_closed,
          seq: row.fw_grp_seq,
          fw_grp_id: row.fw_grp_id,
          name: row.fw_grp_uname,
          total_cnt: row.total_cnt || 0,
          enabled_cnt: row.enabled_cnt || 0,
          disabled_cnt: row.disabled_cnt || 0
        })
      }
    }
    // Page Max 갯수 계산
    if (row.is_closed) pageMaxCount -= row.total_cnt
    // 정책 row 추가
    // 활성, 비활성 체크 안됨
    _.each(row.fw_rule, ruleRow => {
      const copyRule = _.cloneDeep(ruleRow)
      // 기존 그룹ID, 그룹명 원복 백업 (편집 정책 검색 맵 탐색용)
      copyRule.fw_grp_uname_org = copyRule.fw_grp_uname
      copyRule.fw_grp_id_org = copyRule.fw_grp_id
      copyRule.fw_grp_uname = row.fw_grp_uname
      copyRule.fw_grp_id = row.fw_grp_id
      copyRule.use = copyRule.fw_rule_use_yn
      fwEachRule.push(copyRule)
    })
  })
  return { pageMaxCount, fwGroupList, selectGroupList, fwEachRule, fwRulesList }
}
